import { MenuItem, Select } from "@mui/material";
import { Customer } from "../../../services/api/__generated__/backend_gateway-types";

export const CustomerSelectorComponent = (props: {
  onSelect: (customerId: string | null) => void;
  allCustomers: Customer[];
  selectedCustomerId: string | null;
}) => {
  const { onSelect, allCustomers, selectedCustomerId } = props;

  return (
    <Select
      size="small"
      value={selectedCustomerId}
      renderValue={(value) => {
        if (!value) {
          return "Select customer";
        }
        return value;
      }}
    >
      <MenuItem
        value="NO CUSTOMER SELECTED"
        key="NO CUSTOMER SELECTED"
        onClick={() => onSelect(null)}
      >
        Clear selection
      </MenuItem>
      {allCustomers
        ?.slice()
        .sort((a, b) => {
          const nameA = a.name || a.id || "";
          const nameB = b.name || b.id || "";
          return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
        })
        ?.map((customer: Customer) => (
          <MenuItem
            value={customer.id}
            key={customer.id}
            onClick={() => {
              if (customer.id) {
                onSelect(customer.id);
              }
            }}
          >
            {customer.name || customer.id}
          </MenuItem>
        ))}
    </Select>
  );
};
